import React from 'react'; // eslint-disable-line no-unused-vars
import { sessionStorage } from 'dibs-browser-storage';

const AUTO_MODAL_SHOWN = 'autoModalShown';

export const setModalShown = () => {
    sessionStorage.setItem(AUTO_MODAL_SHOWN, true);
};

export const wasModalShown = () =>
    sessionStorage.getItem(AUTO_MODAL_SHOWN) || sessionStorage.getItem('authModalShown');
